/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { Check, Stars01, XClose } from '@untitled-ui/icons-react';
import { Dispatch, SetStateAction } from 'react';

const Checklist = ({
  question,
  key,
  title,
  valid,
  setValid,
  err,
  setErr,
  buttonsLocked,
  isAutomatedVerification,
  isTouched,
  setIsTouched,
}: {
  question: string;
  key: string;
  title: string;
  valid: string[];
  setValid: Dispatch<SetStateAction<string[]>>;
  err: string[];
  setErr: Dispatch<SetStateAction<string[]>>;
  buttonsLocked: boolean;
  isAutomatedVerification: boolean;
  isTouched: boolean;
  setIsTouched: Dispatch<SetStateAction<boolean>>;
}) => {
  const handleValidClick = () => {
    setIsTouched(true);
    setValid((prevState) => [...prevState, key]);
    setErr((prevErr) => (prevErr.includes(key) ? prevErr.filter((item) => item !== key) : prevErr));
  };

  const handleErrClick = () => {
    setIsTouched(true);
    setValid((prevState) => (prevState.includes(key) ? prevState.filter((item) => item !== key) : prevState));
    setErr((prevErr) => [...prevErr, key]);
  };

  const isValid = valid?.includes(key);
  const isErr = err?.includes(key);

  return (
    <Flex mb={5} key={key}>
      <Flex alignItems="flex-start">
        <Flex mt={1}>
          <Button
            borderRadius={4}
            size="sm"
            color="white"
            bgColor={isValid ? 'green.500' : 'gray.500'}
            mr={2}
            onClick={isValid || buttonsLocked ? undefined : handleValidClick}
            pointerEvents={isValid || buttonsLocked ? 'none' : 'auto'}
            cursor={isValid || buttonsLocked ? 'default' : 'pointer'}
            _hover={{ bg: 'green.400' }}
          >
            <Icon as={Check} fontSize="20" />
            {!isTouched && isAutomatedVerification && isValid && <Icon as={Stars01} fontSize="20" ml={2} />}
          </Button>
          <Button
            borderRadius={4}
            size="sm"
            color="white"
            bgColor={isErr ? 'red.500' : 'gray.500'}
            onClick={isErr || buttonsLocked ? undefined : handleErrClick}
            pointerEvents={isErr || buttonsLocked ? 'none' : 'auto'}
            cursor={isErr || buttonsLocked ? 'default' : 'pointer'}
            _hover={{ bg: 'red.500' }}
          >
            <Icon as={XClose} fontSize="20" />
            {!isTouched && isAutomatedVerification && isErr && <Icon as={Stars01} fontSize="20" ml={2} />}
          </Button>
        </Flex>
        <Flex direction="column" ml={5} justifyContent="center">
          <Text fontSize={14} fontWeight={600} whiteSpace="wrap" m={0} p={0}>
            {title}
          </Text>
          <Text fontSize={14} whiteSpace="wrap" m={0} p={0}>
            {question}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Checklist;
